// @ts-nocheck
// Main-thread facade for the places store. The real implementation is
// ./sqlite/locationsCore.js running inside the dedicated SQLite worker (OPFS
// sync access handles are worker-only); every method here is an RPC proxy with
// the same signature and return shape as the old direct version, so callers
// (app/+page, m/+page, syncedMap) need no changes.

import { call, initDb } from './sqlite/client.js';
import { normalizeLocation } from './sqlite/locationsCore.js';

export class LocationsDataService {
	constructor(ownerUid = '') {
		this.ownerUid = typeof ownerUid === 'string' ? ownerUid : '';
	}

	setOwnerUid(ownerUid) {
		this.ownerUid = typeof ownerUid === 'string' ? ownerUid : '';
	}

	async initialize() {
		await initDb();
		return true;
	}

	add(location) {
		return call('locations.add', this.ownerUid, location);
	}

	addLocations(locations) {
		return call('locations.addLocations', this.ownerUid, locations);
	}

	// Like addLocations, but reports { ids, added, updated, unchanged }.
	importLocations(locations) {
		return call('locations.importLocations', this.ownerUid, locations);
	}

	getAll() {
		return call('locations.getAll', this.ownerUid);
	}

	getAllForOwner(ownerUid) {
		return call('locations.getAll', ownerUid || '');
	}

	update(locationData) {
		return call('locations.update', this.ownerUid, locationData);
	}

	delete(id) {
		return call('locations.delete', this.ownerUid, id);
	}

	deleteAll() {
		return call('locations.deleteAll', this.ownerUid);
	}

	getLocationsByTimeRange(start, end) {
		return call('locations.getLocationsByTimeRange', this.ownerUid, start, end);
	}

	// Pure — runs locally, no worker round-trip.
	normalizeLocation(location) {
		return normalizeLocation(location);
	}
}
